import { useQuery } from "@tanstack/react-query";
import { buyerSubmissionsApi } from "@/api/buyers";
import { buyerSubmissionKeys } from "@/hooks/buyers/buyerKeys";

/** The Buyer intro card's one read — shared by the panel and the tab (which
 *  needs it to decide whether the card starts open, D4), so both read one cache
 *  entry. */
export function useIntroEmailState(submissionId: string) {
  return useQuery({
    queryKey: buyerSubmissionKeys.introEmail(submissionId),
    queryFn: () => buyerSubmissionsApi.getIntroEmail(submissionId),
    enabled: Boolean(submissionId),
  });
}
